import ActiveCreatePoll from "../images/links/active_create_group_icon.svg";
import ActiveCreateMergedPoll from "../images/links/active_create_polls_icon.svg";
import ActiveCreateAttendance from "../images/links/active_attendance_icon.svg";
import ActiveGradeBook from "../images/links/active_gradebook_icon.svg";
import ActivePollGradeBookIcon from "../images/links/active_poll_gradebook_icon.svg";
import ActiveAttendanceGradeBookIcon from "../images/links/active_attendance_gradebook_icon.svg";
import ActiveHome from "../images/links/active_home_icon.svg";
import ActiveIntegration from "../images/links/active_integration_icon.svg";
import ActiveManageCourses from "../images/links/active_manage_courses_icon.svg";
import ActiveManagePolls from "../images/links/active_manage_polls_icon.svg";
import ActiveManageUsers from "../images/links/active_manage_users_icon.svg";
import ActiveSettings from "../images/links/active_settings_icon.svg";
import ActiveMarketplace from "../images/links/active_marketplace_icon.svg";
import CreatePoll from "../images/links/create_group_icon.svg";
import CreateMergedPoll from "../images/links/create_poll_icon.svg";
import CreateAttendanceIcon from "../images/links/create_attendance.svg";
import GradeBook from "../images/links/gradebook_icon.svg";
import PollGradeBookIcon from "../images/links/poll_gradebook_icon.svg";
import AttendanceGradeBookIcon from "../images/links/attendance_gradebook.svg";
import GradientManageCourses from "../images/links/gradient_manage_courses_icon.svg";
import GradientSettings from "../images/links/gradient_settings_icon.svg";
import Home from "../images/links/home_icon.svg";
import Integration from "../images/links/integration_icon.svg";
import ManageCourses from "../images/links/manage_courses_icon.svg";
import ActiveQuestionBanks from "../images/links/questionbank_active_icon.svg";
import ManageQuestionBanks from "../images/links/questionbank_icon.svg";
import ManagePolls from "../images/links/manage_polls_icon.svg";
import ManageUsers from "../images/links/manage_users_icon.svg";
import Settings from "../images/links/settings_icon.svg";
import Marketplace from "../images/links/marketplace_icon.svg";
import Recycle from "../images/recycle.svg";
import ActiveRecycle from "../images/recycle_active.svg";
import ReportParent from "../images/report_parent_icon.svg";
import ActiveReportParent from "../images/report_parent_active_icon.svg";
import Report from "../images/reportIcon.svg";
import ActiveReport from "../images/reportIcon-active.svg";
import MonthlyUsageReport from "../images/report_monthly_usage_icon.svg";
import ActiveMonthlyUsageReport from "../images/report_monthly_usage_active_icon.svg";
import Login from "../images/login.svg";

import {ReactComponent as MCSS_PURPLE} from "../images/question_type_mcss_purple.svg";
import {ReactComponent as MCSS_GREY} from "../images/question_type_mcss_grey.svg";
import {ReactComponent as MCSS_IMG} from "../images/question_type_mcss_img.svg";
import {ReactComponent as SA_PURPLE} from "../images/question_type_sa_purple.svg";
import {ReactComponent as SA_GREY} from "../images/question_type_sa_grey.svg";
import {ReactComponent as SA_IMG} from "../images/question_type_sa_img.svg";
import {ReactComponent as TF_PURPLE} from "../images/question_type_tf_purple.svg";
import {ReactComponent as TF_GREY} from "../images/question_type_tf_grey.svg";
import {ReactComponent as TF_IMG} from "../images/question_type_tf_img.svg";
import {ReactComponent as FITB_PURPLE} from "../images/question_type_fitb_purple.svg";
import {ReactComponent as FITB_GREY} from "../images/question_type_fitb_grey.svg";
import {ReactComponent as FITB_IMG} from "../images/question_type_fitb_img.svg";
import {ReactComponent as CI_PURPLE} from "../images/question_type_clickable_purple.svg";
import {ReactComponent as CI_GREY} from "../images/question_type_clickable_grey.svg";
import {ReactComponent as CI_IMG} from "../images/question_type_clickable_img.svg";
import {ReactComponent as WC_PURPLE} from "../images/question_type_wc_purple.svg";
import {ReactComponent as WC_GREY} from "../images/question_type_wc_grey.svg";
import {ReactComponent as WC_IMG} from "../images/question_type_wc_img.svg";
import {ReactComponent as MH_PURPLE} from "../images/question_type_matching_purple.svg";
import {ReactComponent as MH_GREY} from "../images/question_type_matching_grey.svg";
import {ReactComponent as MH_IMG} from "../images/question_type_matching_img.svg";
import {ReactComponent as RK_PURPLE} from "../images/question_type_rk_purple.svg";
import {ReactComponent as RK_GREY} from "../images/question_type_rk_grey.svg";
import {ReactComponent as RK_IMG} from "../images/question_type_rk_img.svg";
import {ReactComponent as OE_PURPLE} from "../images/question_type_oe_purple.svg";
import {ReactComponent as OE_GREY} from "../images/question_type_oe_grey.svg";
import {ReactComponent as OE_IMG} from "../images/question_type_oe_img.svg";
import {ReactComponent as IB_PURPLE} from "../images/question_type_ib_purple.svg";
import {ReactComponent as IB_GREY} from "../images/question_type_ib_grey.svg";
import {ReactComponent as IB_IMG} from "../images/question_type_ib_img.svg";
import {ReactComponent as RETRO_PURPLE} from "../images/question_type_retro_purple.svg";
import {ReactComponent as RETRO_GREY} from "../images/question_type_retro_grey.svg";
import {ReactComponent as RETRO_IMG} from "../images/question_type_retro_img.svg";
import {ReactComponent as BS_PURPLE} from "../images/question_type_bs_purple.svg";
import {ReactComponent as BS_GREY} from "../images/question_type_bs_grey.svg";
import {ReactComponent as BS_IMG} from "../images/question_type_bs_img.svg";
import CanvasGIF from "../images/how-to-embed-Canvas.gif";
import MoodleGIF from "../images/how-to-embed-Moodle.gif";
import D2LGIF from "../images/how-to-embed-D2L.gif";
import BlackboardGIF from "../images/how-to-embed-Blackboard.gif";

import {ReactComponent as PLATFORM_IOS_ICON} from "../pages/Report/images/platform_ios.svg";
import {ReactComponent as PLATFORM_ANDROID_ICON} from "../pages/Report/images/platform_andriod.svg";
import {ReactComponent as PLATFORM_WINDOWS_ICON} from "../pages/Report/images/platform_windows.svg";
import {ReactComponent as PLATFORM_OTHER_ICON} from "../pages/Report/images/platform_other.svg";
import {ReactComponent as BROWSER_CHROME_ICON} from "../pages/Report/images/browser_chrome.svg";
import {ReactComponent as BROWSER_EDGE_ICON} from "../pages/Report/images/browser_edge.svg";
import {ReactComponent as BROWSER_FIREFOX_ICON} from "../pages/Report/images/browser_firefox.svg";
import {ReactComponent as BROWSER_SAFARI_ICON} from "../pages/Report/images/browser_safari.svg";
import {ReactComponent as BROWSER_MOBILE_APP_ICON} from "../pages/Report/images/browser_mobile_app.svg";
import {ReactComponent as BROWSER_OTHER_ICON} from "../pages/Report/images/browser_other.svg";


import {ReactComponent as GRADED_ACTIVITY_IMG} from "../images/activity_editor_graded_icon.svg";
import {ReactComponent as UNGRADED_ACTIVITY_IMG} from "../images/activity_editor_ungraded_icon.svg";

import CORRECT_ICON from "../images/gradebook-correct-icon.svg";
import PARTIALLY_CORRECT from "../images/gradebook-partially-correct-icon.svg";
import INCORRECT_ICON from "../images/gradebook-incorrect-icon.svg";
import NON_GRADABLE_ICON from "../images/gradebook-non-gradable-icon.svg";
import UN_GRADED_ICON from "../images/gradebook-ungraded-icon.svg";
import UNANSWERED_ICON from "../images/gradebook-unanswered-icon.svg";
import NOT_POSTED_ICON from "../images/gradebook-not-posted-icon.svg";


export const COLLAPSED_SIDE_BAR_WIDTH = 60;
export const EXPANDED_SIDE_BAR_WIDTH = 240;
export const RESPONSIVE_SIDE_BAR_POINT = 900;
export const RELEASE_PAGE_RIGHT_PANEL_OVERLAY_POINT = 1100;

export const REQUIRED_FIELD_ERROR = "this field is required";
export const BLANK_REGEX = /\([^()]+\)/g; // 1 or more characters without limit
export const BLANK_REGEX_NEW = /\([^()]{1,25}\)/g; // 25 characters limit
export const BLANK_REGEX_WRAPPED = /(\([[a-zA-Z0-9!?@#=$&:*<>"';^_%\\\-.+,\/\ ]+\))/g; // 1 or more characters without limit
export const BLANK_REGEX_WRAPPED_NEW = /(\([[a-zA-Z0-9!?@#=$&:*<>"';^_%\\\-.+,\/\ ]{1,25}\))/g; // 25 characters limit
export const GRADE_BOOK_QUESTION_COLUMN_REGEX = /^Q\d*$/;
export const ATTEMPT_REGEX = /^Attempt #\d+$/;
export const SCORE_REGEX = /(^100([.]0{1,2})?)$|(^\d{1,2}([.]\d{1,2})?)$/g;
export const QR_URL_REGEX = /^(?:https?:\/\/)?(?:[a-zA-Z-]+\.engage\.yuja\.com\/qr\/)([0-9]+)$/;

export const POLL_CODE_LENGTH = 6;
export const ANONYMOUS_USERNAME_LENGTH = 6;
export const USERNAME_LENGTH = 4;

export const DEFAULT_TOTAL_QUESTIONS = 5;
export const DEFAULT_POINTS = 10;
export const DEFAULT_TIME_LIMIT = 15;
export const DEFAULT_GET_READY_TIME_LIMIT = 10;
export const DEFAULT_CLASS_RESULT_TIME_LIMIT = 15;
export const DEFAULT_POLL_BREAK_TIME_LIMIT = 5;
export const DEFAULT_COUNT_DOWN_TIME_LIMIT = 5;
export const MINIMUM_POLL_TIME_LIMIT = 60;
export const DEFAULT_POLL_TIME_LIMIT = 1800;
export const DEFAULT_ATTENDANCE_MANUAL_END = true;
export const DEFAULT_ATTENDANCE_TIME_LIMIT = 3600;
export const DEFAULT_ATTENDANCE_SAVED_LOCATIONS = "[]";
export const DEFAULT_GET_READY_ALL_TIME_LIMIT = 10;
export const DEFAULT_POLL_REQUIRED_NAME = false;
export const DEFAULT_POLL_SHOW_CORRECT_ANS = false;
export const DEFAULT_POLL_MAX_ATTEMPTS = -1;
export const DEFAULT_ENTRIES_PER_PARTICIPANT = 1;
export const DEFAULT_SHOWN_ENTRIES = 3;
export const UNTIMED_POLL = -1;
export const UNTIMED_POLL_TIME_LIMIT = 24*60*60;
export const GET_READY = 11;
export const WAIT_LENGTH = 20;
export const TOTAL_LENGTH = WAIT_LENGTH + GET_READY + 3;

export const POLL_TITLE_LENGTH = 100;
export const POLL_TITLE_DROPDOWN_LENGTH = 50;
export const QUESTION_LENGTH = 1000;
export const FITB_QUESTION_LENGTH = 1000; 
export const FITB_BLANK_LENGTH = 25; 
export const MC_ANSWER_LENGTH = 100;
export const SA_ANSWER_LENGTH = 100;
export const FITB_ANSWER_LENGTH = 100;
export const FITB_BLANK_LIMIT = 2;
export const MAX_MH_RESPONSE_DISPLAY = 3;
export const WC_ANSWER_LENGTH = 25; // Word Cloud Response Character Limit
export const WC_DISPLAY_LIMIT = 1; // Show View Answer if more than one entry
export const WC_MAXIMUM_ENTRIES = 10;

export const YUJA_TITLE = "YuJa Engage";

export const MANAGE_POLLS_PAGE_POLL_TITLE_LENGTH = 30;

export const QR_SCANNER_WIDTH = 300;
export const QR_SCANNER_HEIGHT = 300;
export const SHORT_NAME_LENGTH = 20;
export const FULL_NAME_LENGTH = 100;

export const YUJA_INST_CODE = "001";

export const ANY = "ANY";
export const PORTRAIT = "PORTRAIT";
export const LANDSCAPE = "LANDSCAPE";

export const ROLES = {
    ADMINISTRATOR: { value: "ADMINISTRATOR", display: "Admin", labelKey: "roles.administrator" },
    IT_MANAGER: { value: "IT_MANAGER", display: "IT Manager", labelKey: "roles.itManager" },
    CREATOR: { value: "CREATOR", display: "Creator", labelKey: "roles.creator" },
    VIEWER: { value: "VIEWER", display: "Viewer", labelKey: "roles.viewer" },
    ANONYMOUS: { value: "ANONYMOUS", display: "Anonymous", labelKey: "roles.anonymous" }
}

export const CREATION_ROLES = {
    IT_MANAGER: { value: "IT_MANAGER", display: "IT Manager", labelKey: "roles.itManager" },
    CREATOR: { value: "CREATOR", display: "Creator", labelKey: "roles.creator" },
    VIEWER: { value: "VIEWER", display: "Viewer", labelKey: "roles.viewer" },
}

export const ERROR_CODES = {
    USER_ALREDY_EXISTS: "Y009",
    INVALID_CODE: "Y008",
    EXPIRED_SESSION: "Y026",
    INVALID_SESSION: "Y027",
    INVALID_POLL_CODE: "Y029",
    EXPIRED_POLL_CODE: "Y032"
};

export const AUTHORIZATION_TYPE = "Bearer";

export const FROM_HEADERS = { from: "APPLICATION" };

export const HTTP_STATUS = {
    UNAUTHORIZED: 401,
    AUTHORIZE_DENY: 403,
}

export const HOME_PATH = "/home";
export const CSM_HOME_PATH = "/institutions";
export const CSM_ADD_INSTITUTION_PATH = "/institution";
export const CSM_ADMIN_PATTERNS_PATH = "/admin/patterns";
export const CSM_EVENTS_PATH = "/events";
export const CSM_CSM_MANAGEMENT_PATH = "/users";
export const POLL_PATH = "/poll/user";
export const POLL_CHOOSER_PATH = "/poll/choose/";
export const JOIN_PARTICIPANT_PATH = "/qr";
export const LOGIN_PATH = "/";
export const SESSION_WILL_EXPIRED_DURATION = 30 * 60 * 1000;
export const COOKIE_WILL_EXPIRED_DURATION = 24 * 60 * 60 * 1000;
export const SESSION_CHECK_INTERVAL = 60 * 1000;

export const SURVEY_ALL_PAGE_STATE = {
    QUESTION: 'QUESTION',
    RESULT: 'RESULT',
    RESULT_ALL: 'RESULT_ALL',
    NOT_READY: 'NOT_READY'
};
export const ATTENDANCE_PAGE_STATE = {
    LMS_GEOFENCE: 'LMS_GEOFENCE', // LMS view for geofenced attendance
    WAITING: 'WAITING', // waiting for attendance
    CHECK_IN: 'CHECK_IN', // location check in
    QUESTION: 'QUESTION', // attendance question
    THANK_YOU: 'THANK_YOU', // attendance submitted
    // THANK_YOU_CLOSED: 'THANK_YOU_CLOSED', // attendance closed with response
    CLOSED: 'CLOSED', // attendance closed
};

export const SURVEY_ALL_CURRENT_QUESTION_NO_KEY = 'SURVEY_ALL_CURRENT_QUESTION_NO_KEY';

export const QUESTION_TYPES = {
    MCSS: {
        name: 'MCSS',
        description: 'Multiple Choice',
        labelKey: 'questionTypes.mcss.label',
        detailKey: 'questionTypes.mcss.detail',
        iconPurple: MCSS_PURPLE,
        iconGrey: MCSS_GREY,
        image: MCSS_IMG,
    },
    SA: {
        name: 'SA',
        description: 'Short Answer',
        labelKey: 'questionTypes.sa.label',
        detailKey: 'questionTypes.sa.detail',
        iconPurple: SA_PURPLE,
        iconGrey: SA_GREY,
        image: SA_IMG,
    },
    TF: {
        name: 'TF',
        description: 'True or False',
        labelKey: 'questionTypes.tf.label',
        detailKey: 'questionTypes.tf.detail',
        iconPurple: TF_PURPLE,
        iconGrey: TF_GREY,
        image: TF_IMG,
    },
    FITB: {
        name: 'FITB',
        description: 'Fill in the Blank',
        labelKey: 'questionTypes.fitb.label',
        detailKey: 'questionTypes.fitb.detail',
        iconPurple: FITB_PURPLE,
        iconGrey: FITB_GREY,
        image: FITB_IMG,
    },
    CI: {
        name: 'CI',
        description: 'Clickable Image',
        labelKey: 'questionTypes.ci.label',
        detailKey: 'questionTypes.ci.detail',
        iconPurple: CI_PURPLE,
        iconGrey: CI_GREY,
        image: CI_IMG,
    },
    WC: {
        name: 'WC',
        description: 'Word Cloud',
        labelKey: 'questionTypes.wc.label',
        detailKey: 'questionTypes.wc.detail',
        iconPurple: WC_PURPLE,
        iconGrey: WC_GREY,
        image: WC_IMG,
    }, // Survey only
    MH: {
        name: 'MH',
        description: 'Matching',
        labelKey: 'questionTypes.mh.label',
        detailKey: 'questionTypes.mh.detail',
        iconPurple: MH_PURPLE,
        iconGrey: MH_GREY,
        image: MH_IMG,
    }, // Graded Poll only
    RK: {
        name: 'RK',
        description: 'Ranking',
        labelKey: 'questionTypes.rk.label',
        detailKey: 'questionTypes.rk.detail',
        iconPurple: RK_PURPLE,
        iconGrey: RK_GREY,
        image: RK_IMG,
    }, // Survey only
    OE: {
        name: 'OE',
        description: 'Open Discussion',
        labelKey: 'questionTypes.oe.label',
        detailKey: 'questionTypes.oe.detail',
        iconPurple: OE_PURPLE,
        iconGrey: OE_GREY,
        image: OE_IMG,
    },
    IB: {
        name: 'IB',
        description: 'Icebreaker',
        labelKey: 'questionTypes.ib.label',
        detailKey: 'questionTypes.ib.detail',
        iconPurple: IB_PURPLE,
        iconGrey: IB_GREY,
        image: IB_IMG,
    },
    RETRO: {
        name: 'RETRO',
        description: 'Retrospective',
        labelKey: 'questionTypes.retro.label',
        detailKey: 'questionTypes.retro.detail',
        iconPurple: RETRO_PURPLE,
        iconGrey: RETRO_GREY,
        image: RETRO_IMG,
    },
    BS: {
        name: 'BS',
        description: 'Brainstorm',
        labelKey: 'questionTypes.bs.label',
        detailKey: 'questionTypes.bs.detail',
        iconPurple: BS_PURPLE,
        iconGrey: BS_GREY,
        image: BS_IMG,
    }

};
export const SAMPLE_QUESTIONS = [
    { "Question Type": QUESTION_TYPES.MCSS.description, "Question Title": "What is your favourite fruit", "Options": "Apple , Banana , Orange , Grapes", "Answer": "Apple", "Blank Pairs": "" },
    { "Question Type": QUESTION_TYPES.SA.description, "Question Title": "This is a short answer question", "Options": ``, "Answer": "", "Blank Pairs": "" },
    { "Question Type": QUESTION_TYPES.TF.description, "Question Title": "Is this True", "Options": "True, False", "Answer": "True", "Blank Pairs": "" },
    { "Question Type": QUESTION_TYPES.CI.description, "Question Title": "Where is the cat in the image?", "Options": "", "Answer": "", "Blank Pairs": "" },
    { "Question Type": QUESTION_TYPES.MH.description, "Question Title": "Match the capital with the country", "Options": "", "Answer": "{France:Paris , Italy:Rome , Toronto}", "Blank Pairs": "" },
    { "Question Type": QUESTION_TYPES.FITB.description, "Question Title": "This is a fill in the (Blank 1) question with multiple (Blank 2)", "Options": "", "Answer": "", "Blank Pairs": "{Blank 1: Answer1 | Answer2, Blank 2: Answer3 | Answer 4}" },
    { "Question Type": QUESTION_TYPES.WC.description, "Question Title": "What core values do you believe are essential for success?", "Options": "" },
    { "Question Type": QUESTION_TYPES.RK.description, "Question Title": "Rank the following historical events in order of their significance in shaping the modern world.", "Options": "The Industrial Revolution, The signing of the Magna Carta, The discovery of the New World by Columbus, The invention of the internet" },
    { "Question Type": QUESTION_TYPES.OE.description, "Question Title": "In what ways do you believe emerging technologies could help in our everyday lives?", "Options": "" },
    { "Question Type": QUESTION_TYPES.IB.description, "Question Title": "This is a icebreaker question", "Options": ``, "Answer": "", "Blank Pairs": "" },
    { "Question Type": QUESTION_TYPES.RETRO.description, "Question Title": "This is a retrospective question", "Options": ``, "Answer": "", "Blank Pairs": "" },
    { "Question Type": QUESTION_TYPES.BS.description, "Question Title": "This is a brainstorm question", "Options": ``, "Answer": "", "Blank Pairs": "" },
];

export const imageSuffixArr = ['.png', '.jfif', '.pjpeg', '.jpg', '.jpeg', '.pjp'];
export const videoSuffixArr = ['.mp4'];
export const fileSuffixArr = ['.pdf', '.doc', '.docx', '.txt', '.png', '.jfif', '.pjpeg', '.jpg', '.jpeg', '.pjp', '.mp4'];

export const MCSSoptLower = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
export const MCSSoptUpper = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
export const TFoptions = ['True', 'False'];

// Accessible Colors with White Background:
export const WORD_CLOUD_COLORS = ['#004A7F', '#006B3F', '#7F0000', '#4C005C', '#BF4600', '#333333', '#006E99', '#D63838', '#8A2BE2', '#737373', '#008080', '#CF00CF', '#000080', '#808000', '#B85B39', '#800000', '#4B0082', '#7F6C5B'];
export const RANKING_COLORS = ['#CE8240', '#50A551', '#499EC5', '#9F85E0', '#758CF0', '#EE63A4', '#C18867', '#EE63A4'];

export const PAGE_TYPE = {
    COMPATIBLE: "0",
    VIEWER: "1",
    OTHER: "2"
};

export const NETWORK_ISSUE = "NETWORK IS NOT WORKING";
export const NETWORK_STATUS_TYPE = {
    ONLINE: "Online",
    OFFLINE: "Offline"
};

export const NETWORK_EFFECTIVE_TYPE = {
    LOW: "2g",
    MID: '3g',
    NORMAL: '4g'
};


export const POLL_STATE = {
    SHARED: "SHARED",
    SHARED_ALL: "SHARED_ALL",
    STOPPED: "STOPPED",
    STOPPED_ALL: "STOPPED_ALL",
    LOCKED: "LOCKED",
    PAUSED: "PAUSED",
    RESUMED: "RESUMED",
    SCHEDULED: "SCHEDULED",
    STOPPED_SCHEDULED: "STOPPED_SCHEDULED",
    CLOSED: "CLOSED"
};

export const QUIZ_STATE = {
    LOADING: "LOADING",
    WAITING: "WAITING",
    PENDING: "PENDING",
    GET_READY: "GET_READY",
    GET_READY_ALL: "GET_READY_ALL",
    POLL_TIME: "POLL_TIME",
    POLL_TIME_ALL: "POLL_TIME_ALL",
    LOCKED: "LOCKED",
    PAUSED: "PAUSED",
    RESUMED: "RESUMED",
    USER_COMPLETE_POLL: "USER_COMPLETE_POLL",
    USER_COMPLETE_SURVEY: "USER_COMPLETE_SURVEY",
    SURVEY_ALL_END: "SURVEY_ALL_END",
    CLASS_RESULT: "CLASS_RESULT",
    SA_RESULT: "SA_RESULT",
    CLASS_RESULT_ALL: "CLASS_RESULT_ALL",
    CLASS_RESULT_ALL_SURVEY: "CLASS_RESULT_ALL_SURVEY",
    EXPIRED: "EXPIRED",
    CLOSED: "CLOSED",
    ATTENDANCE_PAGE: "ATTENDANCE_PAGE"
};

export const POLL_TYPE = {
    GRADED_POLL: "GRADED_POLL",
    SURVEY: "SURVEY",
    ATTENDANCE: "ATTENDANCE",
    MERGED_POLL: "MERGED_POLL",
};

export const SUB_QUESTION_TYPE = {
    PREVIOUS: "PREVIOUS",
    NEXT: "NEXT",
    UNANSWERED: "UNANSWERED"
}

export const REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/;
export const INTEGRATION_TYPES = {
    ADFS: "ADFS",
    SHIBBOLETH: "SHIBBOLETH",
    DCAM: "DCAM",
    GOOGLE: "GOOGLE",
    AZURE: "AZURE",
    CANVAS: "CANVAS",
    BLACKBOARD: "BLACKBOARD",
    MOODLE: "MOODLE",
    D2L: "D2L",
    LTI: "LTI1.3",
    LMS_API: "LMS_API"
};

export const LMS_TYPE = {
    CANVAS: {
        key: "CANVAS",
        name: "Canvas",
        shortName: "Canvas",
        embeddingLearnMore: "https://support.yuja.com/hc/en-us/articles/12271172344599-Adding-a-YuJa-Engage-Poll-as-an-Course-Assignment-in-Canvas#h_01HSEA04YGNTW9847AZGF6VHQP",
        embedGIF: CanvasGIF,
        embedVideo: "https://demo.video.yuja.com/V/Video?v=14013537&node=61209934&a=78116752"
    },
    BLACKBOARD: {
        key: "BLACKBOARD",
        name: "Blackboard",
        shortName: "Blackboard",
        embeddingLearnMore: "https://support.yuja.com/hc/en-us/articles/12270851514007-Adding-a-YuJa-Engage-Poll-to-Your-Course-in-Blackboard-Ultra#h_01JMWY2NWMYT3QJPSQ4SX66DSR",
        embedGIF: BlackboardGIF,
        embedVideo: "https://demo.video.yuja.com/V/Video?v=14013536&node=61209933&a=146540020"
    },
    MOODLE: {
        key: "MOODLE",
        name: "Moodle",
        shortName: "Moodle",
        embeddingLearnMore: "https://support.yuja.com/hc/en-us/articles/13295888183063-Adding-a-YuJa-Engage-Poll-to-Your-Course-in-Moodle#h_01JMWNAQ83011YBZPHKG2CQQ72",
        embedGIF: MoodleGIF,
        embedVideo: "https://demo.video.yuja.com/V/Video?v=14013539&node=61209936&a=115014563"
    },
    D2L: {
        key: "D2L",
        name: "D2L Brightspace",
        shortName: "D2L",
        embeddingLearnMore: "https://support.yuja.com/hc/en-us/articles/13318286702871-Adding-a-YuJa-Engage-Poll-to-Your-Course-in-D2L-Brightspace#h_01JMWC6SAR7V0BV77AQSX894AX",
        embedGIF: D2LGIF,
        embedVideo: "https://demo.video.yuja.com/V/Video?v=14013538&node=61209935&a=11516029"
    },
};

export const IDENTITY_PROVIDER_TYPES = {
    SAML: "SAML",
    LMS: "LMS",
    YUJA: "YuJa"
};

export const LOG_TYPES = {
    INFO: "Info: ",
    WARNING: "Warning: ",
    ERROR: "ERROR: "
};

export const LOG_API_FILES = {
    RESPONSE: "ResponseApiCalls.js",
    PUBLIC: "PublicApiCall.js",
    POLL: "PollApiCalls.js",
    USER: "UserApiCalls.js",
    LTI: "LTIApiCalls.js",
    INST: "InstitutionApiCalls.js",
    COURSE: "CourseApiCalls.js",
    AUTHENTICATION: "AuthenticationApiCalls.js"
};

export const VIEWER_USER_TYPE = {
    MANUAL_GUEST: "MANUAL_GUEST",
    AUTO_GUEST: "AUTO_GUEST",
    LOGGED_IN: "LOGGED_IN",
    LMS_CANVAS: "LMS_CANVAS",
    LMS_BLACKBOARD: "LMS_BLACKBOARD",
    LMS_MOODLE: "LMS_MOODLE",
    LMS_D2L: "LMS_D2L"
};

export const CI_COORDINATE_SIZE = {
    width: 24,
    height: 24
};

export const TOAST_TYPE = {
    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
    INFO: "INFO",
    WARNING: "WARNING",
    MOBILE: "MOBILE"
}


export const PLATFORM_SETTINGS = {
    DISABLE_USER: "DisableUser",
    ANONYMOUS_JOIN: "AnonymousJoin",
    LMS_QUIZ_ATTEMPTS: "LMSQuizAttempts",
    YUJA_LOGIN: "YujaLogin",
    YUJA_NAME: "YujaName",
    PWD_RESET: "PasswordResetEnable",
    SSONAME_ADFS: "SSOName_ADFS",
    SSONAME_SHI: "SSOName_SHI",
    SSONAME_DCAM: "SSOName_DCAM",
    SSONAME_GOOGLE: "SSOName_GOOGLE",
    SSONAME_AZURE: "SSOName_AZURE",
    DEFAULT: "default",
    PRIVATE_EVP_API_LINK: "privateEVPLink",
    PRIVATE_EVP_API_TOKEN: "privateEVPAuthToken"
}

export const DEFAULT_LOGIN_METHODS = {
    YUJA_LOGIN: "1",
    SSONAME_ADFS: "2",
    SSONAME_SHI: "3",
    SSONAME_DCAM: "4",
    SSONAME_GOOGLE: "5",
    SSONAME_AZURE: "6",
}

export const LOGIN_METHODS = {
    YUJA: "YuJa Credentials",
    ADFS: "SSO - ADFS",
    SHIBBOLETH: "SSO - SHIBBOLETH",
    DCAM: "SSO - DCAM",
    GOOGLE: "SSO- GOOGLE",
    AZURE: "SSO - AZURE",
    ENTRA: "SSO - ENTRA"
}

export const USER_SETTINGS = {
    TOAST_MESSAGE_DURATION: "ToastMessageDuration",
    QUESTION_POINTS: "questionPoints",
    QUESTION_PARTICIPATION_POINTS: "questionParticipationPoints",
    QUESTION_DURATION: "questionDuration",
    QUESTION_COUNTDOWN: "questionCountdown",
    QUESTION_ENTRIES: "questionEntries",
    QUESTION_CLASS_RESULT_DURATION: "questionClassResultDuration",
    POLL_DURATION: "pollDuration",
    POLL_COUNTDOWN: "pollCountdown",
    POLL_REQUIRED_NAME: "pollRequirementName",
    POLL_SHOW_CORRECT_ANS: "pollShowCorrectAns",
    POLL_LMS_SYNC: "pollLmsSync",
    POLL_RECORD_ATTEMPTS: "pollRecordAttempts",
    POLL_MAX_ATTEMPTS: "pollMaxAttempts",
    SURVEY_MAX_ATTEMPTS: "surveyMaxAttempts",
    SURVEY_RECORD_ATTEMPTS: "surveyRecordAttempts", 
    POLL_BREAK_DURATION: "pollBreakDuration",
    PPT_AUTO_SHARE: "pptAutoShare",
    ATTENDANCE_MANUAL_END: "attendanceManualEnd",
    ATTENDANCE_DURATION: "attendanceDuration",
    ATTENDANCE_PPT_AUTO_SHARE: "attendancePptAutoShare",
    ATTENDANCE_SAVED_LOCATIONS: "attendanceSavedLocations",
    LANGUAGE: "language"
};

export const DEFAULT_LANGUAGE = "en";


export const AUDIENCE_RESTRICTION = {
    UNRESTRICTED: "UNRESTRICTED", // no restriction - everyone can join
    NAME_REQUIRED: "NAME_REQUIRED", // guests need to provide name
    LOGGED_IN: "LOGGED_IN", // logged in users only
    REGISTERED: "REGISTERED" // logged in users with course access
};
export const DEFAULT_AUDIENCE_RESTRICTION = AUDIENCE_RESTRICTION.UNRESTRICTED;


export const ATTENDANCE_LENGTH_SETTING_DESCRIPTION = " to complete the attendance.";
export const MODAL_CANCEL_TEXT = "Cancel";
export const MODAL_GO_BACK_TEXT = "Go Back";
export const MODAL_SAVE_TEXT = "Save";
export const MODAL_DELETE_TEXT = "Delete";
export const MODAL_CONFIRM_TEXT = "Confirm";
export const YES_TEXT = "Yes";
export const USERNAME = "Username";
export const FIRST_NAME = "First Name";
export const MIDDLE_NAME = "Middle Name";
export const LAST_NAME = "Last Name";
export const EMAIL = "Email";
export const JOIN_POLL = "Join Poll";


export const POLL_TEXT = "Poll";


export const RECORD_ATTEMPT = {
    ALL: {value: 'all', labelKey: 'gradebook.recordAllAttempts'},
    RECENT: {value: 'recent', labelKey: 'gradebook.recordMostRecentAttempt'},
}

export const LMS_GRADEBOOK_SYNC = { // for platform setting
    FIRST: {value: 'first', labelKey: 'gradebook.syncFirstAttempt'},
    RECENT: {value: 'recent', labelKey: 'gradebook.syncMostRecentAttempt'},
    HIGHEST: {value: 'highest', labelKey: 'gradebook.syncHighestScoreAttempt'}
}

export const SYNC_ATTEMPT = { // other cases
    FIRST: {value: 'first', labelKey: 'gradebook.sendFirstAttemptToLms'},
    RECENT: {value: 'recent', labelKey: 'gradebook.sendMostRecentAttemptToLms'},
    HIGHEST: {value: 'highest', labelKey: 'gradebook.sendHighestScoreAttemptToLms'}
}

export const DEFAULT_POLL_LMS_SYNC = LMS_GRADEBOOK_SYNC.FIRST.value;
export const DEFAULT_POLL_RECORD_ATTEMPTS = RECORD_ATTEMPT.ALL.value;

// Support Center:
export const US_CANADA_PHONE = "+1 (888) 257 2278";
export const UK_PHONE = "+44 (800) 368 8712";
export const NED_PHONE = "+31 (800) 280 0355";
export const INT_PHONE = "+1 (408) 457 1036";
export const SUPPORT_EMAIL_ID = "support@yuja.com";

// Gradebook:
export const COURSE_PLACEHOLDER = "Select a course";
export const SEARCH_BY_COURSE_TEXT = "Search by course";
export const SELECT_TEXT = "Select";
export const SEARCH_A_POLL_TEXT = "Select a poll";
export const POLL_DROPDOWN_TEXT = "Poll Dropdown";
export const ATTENDANCE_DROPDOWN_TEXT = "Attendance Dropdown";
export const COURSE_DROPDOWN_TEXT = "Course Dropdown";
export const SEARCH_BY_POLL_TEXT = "Search by title or code";
export const SEARCH_BY_PARTICIPANT_TEXT = "Search by participant";
export const ATTENDANCE_PLACEHOLDER = "Select an attendance";
export const SEARCH_BY_ATTENDANCE_TEXT = "Search by title or code";
// export const BLACKBOARD_GRADEBOOK_TEXT = "Blackboard Gradebook";
export const BLACKBOARD_GRADEBOOK_TEXT = "Blackboard Gradebook";
export const ID_HEADER = "ID";
export const SYNC_GRADEBOOK_TEXT = "Sync Gradebook";
export const GRADE_ATTENDANCE_DESCRIPTION = "Grade whether the participant was present for the attendance.";

// export const HEADER_NEW = 'header'; // for react-table v8
// export const CELL_NEW = 'cell'; // for react-table v8
export const CHECKBOX_COLUMN_ID = 'selection';
export const OPERATION_COLUMN_ID = 'operation';
export const SERIAL_NO_COLUMN_ID = 'serialNo';
export const DATE_COLUMN_ID = 'dateTitle';
export const STUDENT_COLUMN_ID = 'student';
export const STUDENT_COLUMN_INDEX = 0;
export const GEOFENCE_COLUMN_NAME = 'Geofence';
export const GEOFENCE_COLUMN_INDEX = 2;
export const SCORE_COLUMN_ID = 'score';
export const REAL_SCORE_COLUMN_ID = 'RealScore';
export const ATTENDANCE_STATUS_COLUMN_ID = 'attendance';
export const USER_ID_COLUMN_INDEX = 3;
export const CORRECT = 'correct';
export const INCORRECT = 'incorrect';
export const ALL_STATUS_OPTION = { value: 'all', labelKey: 'table.allOptionLabel' };
export const PRESENT_STATUS = 'present';
export const ABSENT_STATUS = 'absent';
export const PRESENT_TEXT = 'Present';
export const ABSENT_TEXT = 'Absent';
export const NOT_GRADED = 'Not Graded'
export const NO_RESPONSE = 'No Response';
export const ATTEMPT = 'Attempt';
export const ATTEMPT_NO_PREFIX = ATTEMPT + ' #';
export const ATTEMPTS = 'attempts';
export const RESPONSES = 'responses';
export const DELETION_TIME = "deletionTime";
export const POLL_TITLE = "pollTitle";
export const POLL_TYPE_HEADER = "Type";
export const POLL_TYPE_ACCESSOR = "pollType";
export const POLL_SHARE_MODE_ACCESSOR = "pollShareMode";
export const QUESTION_HEADER = "Questions";
export const TOTAL_QUESTIONS = "totalQuestions";
export const ACTIVATION_STATUS_HEADER = "Activation Status";
export const POLL_SORT_KEY = "pollSortKey";
export const FEEDBACK_KEY = "feedbackCount";
export const ACTION_HEADER = "Actions";
export const ACTION_KEY = "action";
export const POLL_KEY = "pollKey";
export const FEEDBACK_TITLE_HEADER = "Feedback";
export const FEEDBACK_STUDENT_HEADER = "Student Name";
export const QUESTION_BANK_TITLE_HEADER = "Question Bank Name";
export const FEEDBACK_SATISFACTION_HEADER = "Satisfaction";
export const FEEDBACK_CATEGORY_HEADER = "Category";
export const FEEDBACK_DATE_HEADER = "Date";
export const FEEDBACK_FILE_HEADER = "Attachment";
export const FEEDBACK_DETAIL_HEADER = "Details";
export const GRADE_ATTENDANCE_TEXT = "Grade Attendance";
export const GRADE_TEXT = "Grade";
export const NOTE_PREFIX = "Note:";
// export const GRADE_MODAL_NOTE_TEXT = "Grades will automatically save when adjusted.";
export const GRADE_ATTENDANCE_MODAL_DESCRIPTION = "Choose a participant to grade whether they were present for the attendance based on their location.";


export const WORD_CLOUD_ID = "wordCloud";
export const WORD_CLOUD_DATA = "wordCloudData";
export const NO_RESPONSES_TEXT = "No Responses Yet";
export const QUESTION_IMAGE_ID = "questionImage";

export const UNLIMITED_ATTEMPTS = -1;
export const DEFAULT_TOAST_MESSAGE_DURATION = 5;
export const DEFAULT_PAGINATION_SIZE = 5; // Page Numbers shown in the bottom of the table
export const DEFAULT_ROWS_PER_PAGE = 6; // Rows per page
export const DEFAULT_ATTENDANCE_ROWS_PER_PAGE = 10; // Rows per page
export const PPT_DEFAULT_ROWS_PER_PAGE = 8;
export const POLL_TITLE_CHARACTER_LIMIT = 50;
export const QUESTION_TITLE_CHARACTER_LIMIT = 1000;
export const COURSE_CHARACTER_LIMIT = 50;
export const DEFAULT_PPT_AUTO_SHARE = true;
export const GRADE_BOOK_RESPONSE_STATUS = {
    CORRECT: {
        key: "CORRECT",
        labelKey: "gradebook.statusCorrect",
        icon: CORRECT_ICON,
        order: 1
    },
    PARTIALLY_CORRECT: {
        key: "PARTIALLY_CORRECT",
        labelKey: "gradebook.statusPartiallyCorrect",
        icon: PARTIALLY_CORRECT,
        order: 2
    },
    INCORRECT: {
        key: "INCORRECT",
        labelKey: "gradebook.statusIncorrect",
        icon: INCORRECT_ICON,
        order: 3
    },
    NON_GRADABLE: {
        key: "NON_GRADABLE",
        labelKey: "gradebook.statusNonGradable",
        icon: NON_GRADABLE_ICON,
        order: 4
    },
    UN_GRADED: {
        key: "UN_GRADED",
        labelKey: "gradebook.statusUngraded",
        icon: UN_GRADED_ICON,
        order: 5
    },
    UNANSWERED: {
        key: "UNANSWERED",
        labelKey: "gradebook.statusUnanswered",
        icon: UNANSWERED_ICON,
        order: 6
    },
    NOT_POSTED: {
        key: "NOT_POSTED",
        labelKey: "gradebook.statusQuestionNotShared",
        icon: NOT_POSTED_ICON,
        order: 7
    },
    UNDEFINED: {
        key: "UNDEFINED",
        labelKey: "gradebook.statusUndefinedResponse",
        icon: "",
        order: 8
    }

};


export const ATTENDANCE_GRADE_BOOK_RESPONSE_STATUS = {
    PRESENT: {
        key: "PRESENT",
        labelKey: "gradebook.presentLabel",
        icon: CORRECT_ICON,
        order: 1
    },
    ABSENT: {
        key: "ABSENT",
        labelKey: "gradebook.absentLabel",
        icon: INCORRECT_ICON,
        order: 2
    },
    UN_GRADED: {
        key: "UN_GRADED",
        labelKey: "gradebook.statusUngraded",
        icon: UN_GRADED_ICON,
        order: 3
    },

};

export const FIXED_ANSWER = {
    UNANSWERED: "unanswered",
    OTHER: "other"
}
export const UNANSWERED = "Unanswered";
export const IN_PROGRESS = "In progress";
export const UNGRADED = "ungraded";

export const POLL_SHARE_MODE = {
    SHARE_ALL: "shareAll",
    SHARE_EACH: "shareEach",
    SCHEDULE: "schedule",
    UNKNOWN: "unknown"
}

export const POLL_STATUS_ENUM = {
    SHARE_ALL_GRADED_POLL: "Released Entire Poll", //shareAll and poll type equal to Graded poll
    SHARE_ALL_SURVEY: "Released Entire Survey", //shareAll and poll type equal to Survey
    SHARE_EACH: "Released by Question", //share each
    SCHEDULE: "Scheduled Release", //poll type equal to schedule
    READY_TO_RELEASE: "Ready to Release", //poll type equal to unknown
    UNFINISHED: "Unfinished Draft", // sort key is draft
}

export const USER_CREATION_FIELDS = {
    USERNAME: "userName",
    FIRST_NAME: "firstName",
    MIDDLE_NAME: "middleName",
    LAST_NAME: "lastName",
}

export const ASCII_CODE_A = 65;
export const ASCII_CODE_SMALL_A = 97;

export const MENU_LIST = {
    LOGIN: {
        name: "Login",
        labelKey: "navigation.login",
        path: "/",
        icon: Login,
        activeIcon: Login,
        gradientIcon: Login,
        roles: [ROLES.ANONYMOUS.value,]
    },
    HOME: {
        name: "Home",
        labelKey: "navigation.home",
        path: "/home",
        icon: Home,
        activeIcon: ActiveHome,
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value, ROLES.CREATOR.value, ROLES.VIEWER.value]
    },
    CREATE: {
        name: "Create",
        labelKey: "navigation.create",
        path: "/create",
        altPath: "/edit",
        disabled: true,
        icon: CreatePoll,
        activeIcon: ActiveCreatePoll,
        stateKey: "pollType",
        subStates: [
            {
                key: POLL_TYPE.MERGED_POLL,
                name: "Poll",
                labelKey: "poll.mergedModeText",
                icon: CreateMergedPoll,
                activeIcon: ActiveCreateMergedPoll
            },
            {
                key: POLL_TYPE.ATTENDANCE,
                name: "Attendance",
                labelKey: "attendance.label",
                icon: CreateAttendanceIcon,
                activeIcon: ActiveCreateAttendance
            }
        ],
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value, ROLES.CREATOR.value]
    },
    // JOIN_POLL: {
    //     name: "Join Poll",
    //     path: "",
    //     icon: JoinPoll,
    //     activeIcon: ActiveJoinPoll,
    //     gradientIcon: GradientJoinPoll,
    //     roles: [ROLES.ANONYMOUS.value, ROLES.VIEWER.value]
    // },
    ACTIVITIES: {
        name: "Activities",
        labelKey: "navigation.activities",
        path: "/poll/user",
        parentPage: "/poll",
        icon: ManagePolls,
        activeIcon: ActiveManagePolls,
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value, ROLES.CREATOR.value]
    },
    ACTIVITIES_STUDENT: {
        name: "Activities",
        labelKey: "navigation.activities",
        path: "/student/polls",
        icon: ManagePolls,
        activeIcon: ActiveManagePolls,
        stateKey: "pollType",
        subStates: [
            {
                key: "Graded Poll",
                name: "Poll",
                labelKey: "poll.mergedModeText",
                icon: PollGradeBookIcon,
                activeIcon: ActivePollGradeBookIcon
            },
             {
                key: POLL_TYPE.ATTENDANCE,
                name: "Attendance",
                labelKey: "attendance.label",
                icon: AttendanceGradeBookIcon,
                activeIcon: ActiveAttendanceGradeBookIcon
            }
        ],
        roles: [ROLES.VIEWER.value]
    },
    GRADEBOOK: {
        name: "Grade Book",
        labelKey: "navigation.gradeBook",
        path: "/gradebook",
        icon: GradeBook,
        activeIcon: ActiveGradeBook,
        stateKey: "pollType",
        subStates: [
            {
                key: "Graded Poll",
                name: "Poll",
                labelKey: "poll.mergedModeText",
                icon: PollGradeBookIcon,
                activeIcon: ActivePollGradeBookIcon
            },
            {
                key: POLL_TYPE.ATTENDANCE,
                name: "Attendance",
                labelKey: "attendance.label",
                icon: AttendanceGradeBookIcon,
                activeIcon: ActiveAttendanceGradeBookIcon
            }
        ],
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value, ROLES.CREATOR.value]
    },

    REPORT: {
        name: "Report",
        labelKey: "navigation.report",
        path: "/report/user",
        parentPage: "/report",
        icon: Report,
        activeIcon: ActiveReport,
        roles: [ROLES.CREATOR.value]
    },

    REPORT_ADMIN: {
        name: "Report",
        labelKey: "navigation.report",
        path: "/report",
        icon: ReportParent,
        activeIcon: ActiveReportParent,
        subStates: [
            {
                key: "Institution Report",
                name: "Institution Report",
                labelKey: "navigation.institutionReport",
                subPath: "/report/inst",
                icon: Report,
                activeIcon: ActiveReport
            },
            {
                key: "Usage Report",
                name: "Usage Report",
                labelKey: "navigation.usageReport",
                subPath: "/report/usage",
                icon: MonthlyUsageReport,
                activeIcon: ActiveMonthlyUsageReport
            }
        ],
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value]
    },

    // REPORT_INST: {
    //     name: "Report",
    //     path: "/report/inst",
    //     parentPage: "/report",
    //     icon: Report,
    //     activeIcon: ActiveReport,
    //     roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value]
    // },

    RECYCLEBIN: {
        name: "Recycle Bin",
        labelKey: "navigation.recycleBin",
        path: "/recyclebin",
        icon: Recycle,
        activeIcon: ActiveRecycle,
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value, ROLES.CREATOR.value]
    },
    USERS: {
        name: "Users",
        labelKey: "navigation.users",
        path: "/users",
        icon: ManageUsers,
        activeIcon: ActiveManageUsers,
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value]
    },
    QUESTION_BANKS: {
        name: "Question Banks",
        labelKey: "navigation.questionBanks",
        path: "/QuestionBank",
        parentPage: "/QuestionBank",
        icon: ManageQuestionBanks,
        activeIcon: ActiveQuestionBanks,
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value, ROLES.CREATOR.value]
    },
    COURSES: {
        name: "Courses",
        labelKey: "navigation.courses",
        path: "/course/user",
        icon: ManageCourses,
        activeIcon: ActiveManageCourses,
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value, ROLES.CREATOR.value]
    },
    COURSES_STUDENT: {
        name: "Courses",
        labelKey: "navigation.courses",
        path: "/student/courses",
        icon: ManageCourses,
        activeIcon: ActiveManageCourses,
        roles: [ROLES.VIEWER.value]
    },
    INTEGRATIONS: {
        name: "Integrations",
        labelKey: "navigation.integrations",
        path: "/admin/integration",
        icon: Integration,
        activeIcon: ActiveIntegration,
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value, ROLES.CREATOR.value]
    },
    SETTINGS: {
        name: "Settings",
        labelKey: "navigation.settings",
        path: "/admin/platformsetting",
        icon: Settings,
        activeIcon: ActiveSettings,
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value, ROLES.CREATOR.value]
    },
    SETTINGS_STUDENT: {
        name: "Settings",
        labelKey: "navigation.settings",
        path: "/student/settings",
        icon: Settings,
        activeIcon: ActiveSettings,
        roles: [ROLES.VIEWER.value]
    },

    MARKETPLACE: {
        name: "Marketplace",
        labelKey: "navigation.marketplace",
        path: "/marketplace",
        icon: Marketplace,
        activeIcon: ActiveMarketplace,
        roles: [ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value]
    }
};

export const PPT_MENU_LIST = {
    CREATE: {
        name: "Create",
        labelKey: "navigation.create",
        path: "/create",
        icon: CreatePoll,
        activeIcon: ActiveCreatePoll,
        roles: [ROLES.IT_MANAGER.value, ROLES.CREATOR.value]
    },
    ACTIVITIES: {
        name: "Activities",
        labelKey: "navigation.activities",
        path: "/polls",
        icon: ManagePolls,
        activeIcon: ActiveManagePolls,
        roles: [ROLES.IT_MANAGER.value, ROLES.CREATOR.value]
    },
};

export const VIEWER_WEBSOCKET_MESSAGE = {
    SHARE: "share",
    SHARE_ALL: "shareAll",
    PAUSE: "pause",
    RESUME: "resume",
    STOP: "stop",
    STOP_ALL: "stopAll",
    STOP_SCHEDULED: "stopScheduled",
    LOCK: "lock",
    UPDATE_SCHEDULE_TIME: "updateScheduleTime",
    UPDATE_POLL_TIME: "updatePollTime",
    RESET: "reset"
}

// CreateQuizSidebar:


export const GRADED_POLL = "Graded Poll";
export const SURVEY = "Survey";

export const CREATE_POLL_PATH = "/create";

export const OK_TEXT = "OK";


// Question Banks
export const QUESTIONS_HEADER = "Questions";


// CreateQuizDetailSidebar:

// Question options:
export const QUESTION_DEFAULT_OPTIONS = {
    MCSS: '{"a":"","b":"","c":"","d":""}',
};

// Matching
export const RESPONSE = "Student Keyword Response";

//Tab Participant options

// Student Gradebook
export const VIEW_TEXT = "View";

// Courses:
export const COURSES = "Courses";
export const COURSE_NAME = "Course Name";
export const COURSE_CODE = "Course Code";

// Polls:
export const POLLS = "Activities";
export const CREATE_POLL = "Create Poll";
export const SCHEDULE_TEXT = "Schedule";
export const UNFINISHED = "Unfinished Draft";
export const DRAFT_TEXT = "Draft";
export const DRAFT_NOT_EMBEDDED_TEXT = "Draft (Embed in LMS)";
export const READY_TO_SHARE = "Ready to Release";
export const SHARED_BY_QUESTION = "Released by Question";
export const SHARED_ENTIRELY = "Released Entire Activity";
export const SCHEDULED = "Scheduled Release";

// Poll Search Form:
export const START_DATE = "Start Date";
export const END_DATE = "End Date";

// Taken Polls:
export const TYPE = "Type";
export const ATTENDANCE_PRESENT_RESULT = "You have been marked as present.";
export const ATTENDANCE_ABSENT_RESULT = "You have been marked as absent.";

// Users:
export const USERS = "Users";
export const TOTAL_USERS = "Total Users";
export const TOTAL_IT_MANAGERS = "Total IT Managers";
export const TOTAL_INSTRUCTORS = "Total Creators";
export const TOTAL_STUDENTS = "Total Participants";
export const CREATE_USER = "Create User";

// Platform Setting


export const HOURS = "Hours";
export const MINUTES = "Minutes";


// Keynote presentation question page


//course API

export const INVALID_COURSE_CODE = "Invalid courseCode";
export const INVALID_COURSE_NAME = "Invalid courseName";


export const DELETE_MULTIPLE_USER_CONFIRMATION = "Are you sure you want to delete the {userCount} selected users?";
// schedule poll
export const SCHEDULE = "Schedule";
export const SCHEDULE_POLL_LABEL = "To schedule a poll, choose the dates when it will be available and specify the length of time participants will have to complete the poll once they join.";

// Ended Poll:
export const SUPPORT_PREFIX = "For technical questions, please reach out to";
export const YUJA_ENGAGE_SUPPORT = "YuJa Engage Support";


//create poll page


//Poll Filtering
export const FILTER_POLLS = "Filter Activities";
export const ACTIVATED_STATUS = "Activated";
export const GRADED_MODE = "Graded Poll";
export const MERGED_MODE = "Poll";
export const ATTENDANCE = "Attendance";
export const COURSE_STATUS = "Course";
export const DRAFT_STATUS = "Draft";
export const ALL_STATUS = "All Status";

//Category Filtering

export const ALL_CATEGORY = "All Categories";
export const ALL_SATISFACTION = "All Satisfaction";

// User Filtering:
export const ALL_ROLES = "All Roles";
export const NO_LINKAGE = "No Linkage";
export const LTI = "LTI";
export const LTI_SAML = "LTI SAML";
export const SAML = "SAML";
export const SAML_LTI = "SAML LTI";
export const LINKAGE_TYPES = [NO_LINKAGE, LTI, SAML, SAML_LTI];


// Disable anonymous join
export const ANONYMOUS_JOIN_SETTING_TEXT = "anonymousJoin";

// LMS authenticate


// Integration Page
export const INSTRUCTOR = "Instructor";
export const LTI_FORM_FIELDS = {
    ISS: {
        labelKey: "integration.ltiFields.iss.label",
        placeholderKey: "integration.ltiFields.iss.placeholder",
        errorMsgKey: "integration.ltiFields.iss.errorMsg",
        descriptionKey: "integration.ltiFields.iss.description",
        tooltipKey: "integration.ltiFields.iss.tooltip", // takes {lms}
    },
    CLIENT_ID: {
        labelKey: "integration.ltiFields.clientId.label",
        placeholderKey: "integration.ltiFields.clientId.placeholder",
        errorMsgKey: "integration.ltiFields.clientId.errorMsg",
        descriptionKey: "integration.ltiFields.clientId.description",
        tooltipKey: "integration.ltiFields.clientId.tooltip", // takes {lms}
    },
    OIDC: {
        labelKey: "integration.ltiFields.oidc.label",
        placeholderKey: "integration.ltiFields.oidc.placeholder",
        errorMsgKey: "integration.ltiFields.oidc.errorMsg",
        descriptionKey: "integration.ltiFields.oidc.description",
        tooltipKey: "integration.ltiFields.oidc.tooltip", // takes {lms}
    },
    JWKS: {
        labelKey: "integration.ltiFields.jwks.label",
        placeholderKey: "integration.ltiFields.jwks.placeholder",
        errorMsgKey: "integration.ltiFields.jwks.errorMsg",
        descriptionKey: "integration.ltiFields.jwks.description",
        tooltipKey: "integration.ltiFields.jwks.tooltip", // takes {lms}
    },
    OAUTH: {
        labelKey: "integration.ltiFields.oauth.label",
        placeholderKey: "integration.ltiFields.oauth.placeholder",
        errorMsgKey: "integration.ltiFields.oauth.errorMsg",
        descriptionKey: "integration.ltiFields.oauth.description",
        tooltipKey: "integration.ltiFields.oauth.tooltip", // takes {lms}
    },
    DEPLOYMENT: {
        labelKey: "integration.ltiFields.deployment.label",
        placeholderKey: "integration.ltiFields.deployment.placeholder",
        errorMsgKey: "integration.ltiFields.deployment.errorMsg",
        descriptionKey: "integration.ltiFields.deployment.description",
        tooltipKey: "integration.ltiFields.deployment.tooltip", // takes {lms}
    },
};

export const LTI_DEFAULT_ENDPOINTS = {
    CANVAS: {
        oidcEndpoint: "https://canvas.instructure.com/api/lti/authorize_redirect",
        jwksEndpoint: "https://canvas.instructure.com/api/lti/security/jwks",
    },
    BLACKBOARD: {
        oidcEndpoint: "https://developer.blackboard.com/api/v1/gateway/oidcauth",
        oAuth2Endpoint: "https://developer.blackboard.com/api/v1/gateway/oauth2/jwttoken",
        getJwksEndpoint: (clientId) =>
            clientId ? `https://developer.blackboard.com/api/v1/management/applications/${clientId}/jwks.json` : "",
    },
    D2L: {
        oAuth2Endpoint: "https://auth.brightspace.com/core/connect/token",
        getOidcEndpoint: (iss) => iss ? `${iss.replace(/\/$/, "")}/d2l/lti/authenticate` : "",
        getJwksEndpoint: (iss) => iss ? `${iss.replace(/\/$/, "")}/d2l/.well-known/jwks` : "",
    },
    MOODLE: {
        getOidcEndpoint: (iss) => iss ? `${iss.replace(/\/$/, "")}/mod/lti/auth.php` : "",
        getJwksEndpoint: (iss) => iss ? `${iss.replace(/\/$/, "")}/mod/lti/certs.php` : "",
        getOAuth2Endpoint: (iss) => iss ? `${iss.replace(/\/$/, "")}/mod/lti/token.php` : "",
    },
};

export const INTEGRATION_TYPES_LOWERCASE = {
    ADFS: "Adfs",
    SHIBBOLETH: "Shibboleth",
    DCAM: "Dcam",
    GOOGLE: "Google",
    AZURE: "Azure",
    CANVAS: "Canvas",
    BLACKBOARD: "Blackboard",
    MOODLE: "Moodle",
    D2L: "D2L",
};

// Per-LMS-type field names that together make up the LMS API access key, keyed by
// INTEGRATION_TYPES_LOWERCASE value. Used to tell whether pending unsaved changes touch the
// access key specifically (as opposed to e.g. domain/linkage settings).
export const LMS_ACCESS_KEY_FIELDS = {
    [INTEGRATION_TYPES_LOWERCASE.MOODLE]: ["apiAccessToken"],
    [INTEGRATION_TYPES_LOWERCASE.CANVAS]: ["apiAccessKeyClientId", "apiAccessKeyClientSecret"],
    [INTEGRATION_TYPES_LOWERCASE.D2L]: ["appId", "appKey"],
    [INTEGRATION_TYPES_LOWERCASE.BLACKBOARD]: ["appKey", "appSecret"],
};

export const INTEGRATION_TYPES_DETAILS = {
    ADFS: "SSO - ADFS [SAML]",
    SHIBBOLETH: "SSO - Shibboleth [SAML]",
    DCAM: "SSO - DCAM [SAML]",
    GOOGLE: "SSO - Google Apps",
    AZURE: "SSO - Azure",
    LTI: "LMS - LTI 1.3",
    LMS_API: "LMS - API"
};

export const blackboardRoles = [{display: "Student", value: "studentRole"}, {display: "Instructor", value: "instructorRole"},
    {display: "Grader", value: "graderRole"}, {display: "Course Builder", value: "courseBuilderRole"},
    {display: "Teaching Assistant", value: "teachingAssistantRole"}, {display: "Guest", value: "guestRole"},
    {display: "Administrator", value: "adminRole"}, {display: "Other", value: "otherRole"}
];

export const canvasRoles = [{display: "Administrator", value: "adminRole"}, {display: "Teacher", value: "teacherRole"},
    {display: "Teaching Assistant", value: "teachingAssistantRole"}, {display: "Designer", value: "designerRole"},
    {display: "Observer", value: "observerRole"}, {display: "Student", value: "studentRole"}
];

export const moodleRoles = [{display: "Student/Course Creator", value: "studentRole"}, {display: "Teacher/Non-editing Teacher/Manager", value: "instructorRole"},
    {display: "Administrator", value: "adminRole"}
];

export const d2lRoles = [{display: "Student/Course Creator", value: "studentRole"}, {display: "Instructor", value: "instructorRole"},
    {display: "Administrator", value: "adminRole"}
];

export const LTI_USER_MAPPING = {
    STUDENT: "Student",
    INSTRUCTOR: "Instructor",
    GRADER: "Grader",
    COURSE_BUILDER: "Course Builder",
    TEACHER: "Teacher",
    TEACHING_ASSISTANT: "Teaching Assistant",
    GUEST: "Guest",
    OTHER: "Other",
    ADMIN: "Administrator",
    DESIGNER: "Designer",
    OBSERVER: "Observer",
    STUDENT_COURSE: "Student/Course Creator",
    TEACHER_MANAGER: "Teacher/Non-editing Teacher/Manager"
};

// Share Poll Modal:

// Poll Time Limit Modal:

// Activity Options Modal:
// export const POLL_OPTIONS_LIMIT_MODAL_CANCEL = "Cancel";
// export const POLL_OPTIONS_LIMIT_MODAL_CONFIRM = "Save";

// Schedule Modal:
// export const REMINDER_TIME_OFFSET = (15 * 60 * 1000);
export const EMAIL_NOTIFICATION_OPTIONS = [
    // { value: 0, label: "never" },
    { value: 900, labelKey: "questionBuilder.emailNotificationOptions.min15" },
    { value: 1800, labelKey: "questionBuilder.emailNotificationOptions.min30" },
    { value: 3600, labelKey: "questionBuilder.emailNotificationOptions.hour1" },
    { value: 7200, labelKey: "questionBuilder.emailNotificationOptions.hour2" },
    { value: 86400, labelKey: "questionBuilder.emailNotificationOptions.day1" }
];

// Delete Modal:
export const DELETE_POLL_MODAL_BODY = "Are you sure you want to delete the activity? Doing so will remove responses recorded in the gradebook.";

// QR Landing Page

// Share Poll Page
export const OPEN = "Open ";
export const CLOSE = "Close ";
export const STOP = "Stop ";
export const QUESTION = "Question ";
export const OPTIONS = "Options";
export const IMAGE = "Upload Image";
export const MCSS_ADD_OPTION_TEXT = "Add Option";
export const GO_BACK = "View all questions";
export const BROWSER_TYPES = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Edge: "Edge",
    Safari: "Safari",
    MobileApp: "Mobile App",
    Other: "Other"
};
export const PLATFORM_TYPES = {
    Apple: "Apple",
    iPhone: "iOS",
    Mac: "Mac OS",
    iPad: "iPad OS",
    Windows: "Windows",
    Android: "Android"
};
// export const ASSOCIATE_COURSE_TEXT = "Associate Poll with Course";
// export const ASSOCIATE_COURSE_BODY_TEXT = "To associate the poll with a course, select the course from the list below.";
// export const ASSOCIATE_COURSE_BUTTON_TEXT = "Select Course";
export const RESPONSE_TITLE = "Response";
export const WAITING_PARTICIPANTS_JOIN_TEXT = "Waiting for Participants to Join";
export const Q_TEXT = "Q";

//test

// Release Question Modal

// Release Poll Modal

// Delete/Discard Question Modal
// export const DISCARD_MODAL_TITLE = "Discard Changes";

// Add/Update Question Modal
// export const UPDATE_QUESTION_MODAL_TITLE = "Update Question";

//Join poll modal


// Navbar
export const RESULTS = "Results";


export const ATTENDANCE_DEFAULT_TITLE = "Attendance - date";
export const DATE_TO_REPLACE = "date";

export const PREVIEW_TEXT = "Preview";

//get ready page
export const GET_READY_PAGE_TIME_LIMIT_1ST_PART = "You will have";
export const GET_READY_PAGE_TIME_LIMIT_2ND_PART = "to answer all questions!";
export const GET_READY_PAGE_TIMER_COUNTER_DESCRIPTION = "Get ready! The question will appear in";

// local storage
export const SESSION = "session";
export const TIME_OFFSET = "timeOffset";
export const QUESTIONS = "questions";
export const SA_RESULT = "SAResult";

// external integration
export const TOPHAT = "Top Hat";
export const MENTIMETER = "Mentimeter";
export const POLL_EVERYWHERE = "Poll Everywhere";
export const WOOCLAP = "Wooclap";
export const INTEGRATED_PRODUCTS = [
    {label: MENTIMETER, value: MENTIMETER}, 
    {label: TOPHAT, value: TOPHAT}, 
    {label: POLL_EVERYWHERE, value: POLL_EVERYWHERE},
    {label: WOOCLAP, value: WOOCLAP}
];
export const MENTIMETER_EXTENSION_ID = "jbjniknpaofjfnghbocbhcppplchkkhp";
export const TOPHAT_EXTENSION_ID = "bgdaaeabdabncnacphdgiafkhmjfodio";
export const POLL_EVERYWHERE_EXTENSION_ID = "hddappnkhbmbfnpekaejnneejhohdokh";
export const WOOCLAP_EXTENSION_ID = "gpnhapiepaakegflbachpdkgcfdhakmi";
export const LOGOUT_CHROME_EXT_MESSAGE = "removeChromeExtSessionInfo";
export const GET_CHROME_EXT_MESSAGE = "getChromeSessionInfo";

// Activity Chooser
export const INSERT_HEADER = "Insert";
export const ACTION_ID = "action";

// Poll chooser confirm
export const POLL_CHOOSER_CONFIRM_DONT_SHOW_AGAIN = "Do not show this again";

// LMS API Integration
export const ACCESS_TOKEN = "Access Token";


//Take Embedded poll guide
export const EMBEDDED_POLL_GUIDE_REDIRECT_LOG_MESSAGE = "Can not Access the activity. Viewer has to click to the Activity link of LMS to take the activity.";


// accessibility roles narrator
export const BUTTON = "button";
export const TOGGLE = "toggle";
export const TEXTBOX = "paragraph";
export const LINK = "link";
export const NONE = "none";
export const IMG = "img";
export const CLOSE_MODAL = "Close Modal";
export const QUESTION_LABEL = "Question";
export const STATUS_LABEL = "Status";
export const FITB_BLANK = "______";

// accessibility creator narrator
export const MODAL = " modal";
export const VIEW_RESULTS = "View results for poll: ";
export const VIEW_RESULTS_TEXT = "View Results";
export const RADIAL_LABEL = " radial button ";
export const TEXT_BOX = "Text box. Option ";
export const PREMISE_SELECTED = "Text box. Premise ";
export const DATE = "Date ";
export const TITLE = "Title ";
export const MODE = "Mode ";
export const STD_LABEL = "Student ";
export const ATMPT_LABEL_2 = " for student";
export const CANCEL_USER = "Cancel Create User.";
export const TEXT_BOX_MODAL = "Text box enter ";
export const ROLE_LABEL = "Role ";
export const SELECT_LABEL = "Dropdown. Select ";
export const YUJA_LOGIN_OPTION_TITLE = "Engage Credentials";
export const ADFS_LOGIN_OPTION_TITLE = "SSO - ADFS";
export const SHIBBOLETH_LOGIN_OPTION_TITLE = "SSO - Shibboleth";
export const DCAM_LOGIN_OPTION_TITLE = "SSO - DCAM";
export const GOOGLE_LOGIN_OPTION_TITLE = "SSO - Google";
export const AZURE_LOGIN_OPTION_TITLE = "SSO - Microsoft Entra ID";

// websocket roles
export const WEBSOCKET_STUDENT = "STUDENT";
export const WEBSOCKET_INSTRUCTOR = "INSTRUCTOR";

export const MOBILE_APP_STORE_URL = "https://apps.apple.com/ca/app/yuja-engage/id6446036970";
export const MOBILE_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.vaarananyuja.yujaengagemobile";

//websocket action
export const WEBSOCKET_MESSAGE_REMOVE_CONNECTIONS_ACTION = "removeConnections";
export const WEBSOCKET_MESSAGE_POST_HEARTBEAT_ACTION = "postHeartbeat";
export const WEBSOCKET_POST_HEARTBEAT_INTERVAL = 20000;
export const WEBSOCKET_CHECK_HEARTBEAT_INTERVAL = 5000;
export const WEBSOCKET_MAX_TOLERANCE_HEARTBEAT_GAP = 60000;


export const YUJA_SUPPORT_LINK = "https://support.yuja.com";


//PPT web view page
export const PPT_ROOT_PATH = "/PPT";
export const PRESENTATION_PATH = "/presentation";
export const PPT_WEBVIEW_POLL_TABLE_GUIDE_LINE = "Select #activityType to insert into your presentation. ";
export const PPT_WEBVIEW_REFRESH_BUTTON = "Refresh";
export const INSTITUTIONS = "Institutions";
export const PPT_PLUGIN_INSTALL_ZIP_FILE_NAME = "Engage PowerPoint Add-in.zip";
export const MOODLE_PLUGIN_ZIP_FILE_NAME = "engage-moodle-plugin.zip";


// Recently Modified Polls:

export const FEEDBACK_BUTTON_TEXT = "Feedback";
export const FEEDBACK_MODAL_SUB_TITLE = "Please provide your feedback.";
export const FEEDBACK_MODAL_SUB_TITLE_SUFFIX = "poll.";
export const FEEDBACK_TEXT_PLACEHOLDER = "Please give as much detail as you can about your idea or suggestion. We'll reach out to you.";
export const SATISFACTION_POOR_TEXT = "Poor";
export const SATISFACTION_SATISFIED_TEXT = "Satisfied";
export const SATISFACTION_GOOD_TEXT = "Good";
export const SATISFAcTION_EXCELLENT_TEXT = "Excellent";
export const FEEDBACK_CATEGORY = {
    Suggestion: "Suggestion",
    Comment: "Comment",
    Other: "Other"
};


export const PARTICIPANT_TIME_INTRO = "Enter how much time participants have to complete the #activityType after it is released.";

// Login Page:


// Sidebar
// export const CREATE_POLL = "Create Poll";
// export const POLL_SURVEY_GRADEBOOK = "Polls and Surveys";
export const IMAGE_UPLOADING_PLACEHOLDER = "IMAGE_UPLOADING_PLACEHOLDER";
export const VIDEO_UPLOADING_PLACEHOLDER = "VIDEO_UPLOADING_PLACEHOLDER";

// Attendance:
export const DEFAULT_GEOFENCE_LAT = 0;
export const DEFAULT_GEOFENCE_LNG = 0;
export const DEFAULT_GEOFENCE_RAD = 10;
export const MIN_RADIUS = 10; // 10 meters
export const MAX_RADIUS = 10000; // 10 km
// export const LOCATION_SEARCH_PLACEHOLDER = "Search Location by city, neighbourhood or ZIP code.";
// export const LOCATION_API_URL = `https://us1.locationiq.com/v1/search?key={ACCESS_TOKEN}&q={SEARCH_STRING}&format=json`;
export const INSTRUCTOR_LOCATION_TIMEOUT = 3000;
export const INSTRUCTOR_LOCATION_CONFIG = {
    enableHighAccuracy: true, // high accuracy
    maximumAge: Infinity, // get cached position if any
    timeout: INSTRUCTOR_LOCATION_TIMEOUT // maximum time to wait for a response
};
export const VIEWER_LOCATION_TIMEOUT = 5000;
export const VIEWER_LOCATION_CONFIG = {
    enableHighAccuracy: true, // high accuracy
    maximumAge: 0, // get latest position
    timeout: VIEWER_LOCATION_TIMEOUT // maximum time to wait for a response
};
export const MAX_SAVED_LOCATIONS = 5;
export const LOCATION_NAME_LENGTH = 50;

// Poll Ready:
export const ALLOW_LOCATION_ACCESS_SUPPORT_LINK = "https://support.yuja.com/hc/en-us/articles/22108689371671-How-to-Share-Your-Location-for-Attendance-Tracking";
export const SA_NO_RESPONSE_EXPLAIN_RELEASE_PAGE = "You can view the responses of participants as they complete this question."
export const IFRAME_PERMISSION_ERROR_MESSAGE = "Geolocation error: Geolocation has been disabled in this document by permissions policy..";
export const LOCATION_ACCURACY_THRESHOLD = 100;
export const LOCATION_MESSAGE = {
    LOCATING: "Finding your location.",
    SUCCESS_IN_GEOFENCE: "You are within the geofenced location.",
    SUCCESS_OUTSIDE_GEOFENCE: "You are outside the geofenced location.",
    BROWSER_NOT_SUPPORTED: "Geolocation is not supported by your browser. We recommend using Google Chrome.",
    PERMISSION_DENIED: "Please enable location access on your device.",
    POSITION_UNAVAILABLE: "Your location could not be determined. You can still take the attendance by selecting the Check-In button.",
    TIMEOUT: "Your location could not be determined. You can still take the attendance by selecting the Check-In button.",
    UNKNOWN_ERROR: "Your location could not be determined. You can still take the attendance by selecting the Check-In button.",
    IFRAME_PERMISSION_ERROR: "Your location could not be shared. Please click the Open in New Tab icon located in the top-right corner of Engage and try again.",
    LOWER_ACCURACY: "Your exact location cannot be determined. Please allow access to location services on this device or use a laptop."
};
export const LOCATION_MESSAGE_GB_DISPLAY = {
    LOCATING: "Could not find location.",
    SUCCESS_IN_GEOFENCE: "Within the geofenced location.",
    SUCCESS_OUTSIDE_GEOFENCE: "Outside of the geofenced area.",
    BROWSER_NOT_SUPPORTED: "Browser not supported.",
    PERMISSION_DENIED: "The participant denied access, or the device’s GPS failed.",
};
// `Within a ${accuracy}-meter radius of the geofenced area`

export const PRIVACY_POLICY_URL = "https://www.yuja.com/documentation/privacy-policy/";
export const ATTENDANCE_COUNTDOWN_START = 10;


//ppt insertion completed page


export const PPT_POLLS_TABLE_ACTION_HEADER = "Action";
export const PPT_POLLS_DATE_ACCESSOR = "updatedDatePK";


export const IMPORT_QUESTIONS_TEXT = "Import Questions";
export const LEARN_MORE_LINK = "https://support.yuja.com/hc/en-us/articles/24010160873495-How-to-Import-Questions-for-a-Poll-or-Survey-Using-a-CSV-File#h_01HZQVHBT3JT8471YPZRJGS5GN";


// View Poll Modal
export const VIEW_POLL_MODAL_QUE_TYPE_HEADER = "Question Type";


export const OPEN_ENDED_TIME_SORT = "Time";
export const OPEN_ENDED_LIKE_SORT = "Likes";
export const OPEN_ENDED_DISLIKE_SORT = "Dislikes";


//report page


export const REPORT_ACTIVITY_PIE_CHART_PLATFORM_LABEL = "Platform";
export const REPORT_ACTIVITY_PIE_CHART_BROWSER_LABEL = "Browser";


export const REPORT_INSTITUTION_PAGE_TAB_KEY = {
    COURSES: "Courses",
    STANDALONE: "Standalone",
};

export const REPORT_COURSE_PAGE_TAB_KEY = {
    POLLS: "Polls",
    ATTENDANCES: "Attendances",
};


export const REPORT_INSTITUTION_COURSE_TABLE_HEADERS = {
    RANK: {name: "rank", labelKey: "report.columnRank"},
    COURSE_CODE: {name: "courseCode", labelKey: "report.columnCourseCode"},
    COURSE_NAME: {name: "courseName", labelKey: "report.columnCourseName"},
    TOTAL_ACTIVITIES: {name: "activityCount", labelKey: "report.columnTotalActivities"},
    ACTION: {name: "action", labelKey: "common.actionsLabel"},
};


export const REPORT_INSTITUTION_NAN_COURSE_TABLE_HEADERS = {
    METRIC_NAME: {name: "metricName", labelKey: "report.columnMetricName"},
    COUNT: {name: "count", labelKey: "report.columnTotalCount"},
};


export const REPORT_COURSE_ACTIVITY_TABLE_HEADERS = {
    POLL_INDEX: {name: "index", labelKey: "report.columnNumber"},
    ATTENDANCE_INDEX: {name: "index", labelKey: "report.columnNumber"},
    TITLE: {name: "pollTitle", labelKey: "report.columnTitle"},
    PARTICIPANT_COUNT: {name: "participantCount", labelKey: "report.columnParticipantsCount"},
    DATE: {name: "date", labelKey: "report.columnDate"},
    ACTION: {name: "action", labelKey: "common.actionsLabel"},
};


export const REPORT_ACTIVITY_QUESTION_TABLE_HEADERS = {
    SERIAL_NO: {name: "serialNo", labelKey: "report.columnNumber"},
    TITLE: {name: "queTitle", labelKey: "report.columnQuestionTitle"},
    TYPES: {name: "questionType", labelKey: "report.columnQuestionTypes"},
    WEIGHTAGE: {name: "weightage", labelKey: "report.columnPointsAssigned"},
    FINISHED_COUNT: {name: "finishedCount", labelKey: "report.columnFinished"},
    INCOMPLETE_COUNT: {name: "incompleteCount", labelKey: "report.columnIncomplete"},
};


export const REPORT_BROWSER_TYPES = {
    CHROME: {name: "Chrome", icon: BROWSER_CHROME_ICON, labelKey: "report.browserChrome"},
    FIREFOX: {name: "Firefox", icon: BROWSER_FIREFOX_ICON, labelKey: "report.browserFirefox"},
    EDGE: {name: "Edge", icon: BROWSER_EDGE_ICON, labelKey: "report.browserEdge"},
    SAFARI: {name: "Safari", icon: BROWSER_SAFARI_ICON, labelKey: "report.browserSafari"},
    MOBILE_APP: {name: "Mobile App", icon: BROWSER_MOBILE_APP_ICON, labelKey: "report.browserMobileApp"},
    OTHERS: {name: "Others", icon: BROWSER_OTHER_ICON, labelKey: "report.browserOthers"},
};
export const REPORT_PLATFORM_TYPES = {
    APPLE: {name: "Apple", icon: PLATFORM_IOS_ICON, labelKey: "report.platformApple"},
    ANDROID: {name: "Android", icon: PLATFORM_ANDROID_ICON, labelKey: "report.platformAndroid"},
    WINDOWS: {name: "Windows", icon: PLATFORM_WINDOWS_ICON, labelKey: "report.platformWindows"},
    OTHERS: {name: "Others", icon: PLATFORM_OTHER_ICON, labelKey: "report.platformOthers"}
};


export const SCREEN_TYPE = {
    DESKTOP: "DESKTOP",
    TABLET: "TABLET",
    MOBILE: "MOBILE"
}

export const YUJA_DROPDOWN_SIZE = {SMALL: "small", MEDIUM: "medium", LARGE: "large"};
export const LATEX_REG_EXP = /\$latex\s([^$]+)\$/g;
export const CHARACTERS_TEXT = "characters";


// export const WELCOME_TO_PLATFORM_TEXT  = "Welcome to the {institutionName}";
export const WELCOME_TO_PLATFORM_TEXT  = "Welcome to the YuJa Engage";
export const SIGN_IN_TO_YOUR_ACCOUNT_TEXT  = "Please sign in to your account.";
export const ENTER_USERNAME_TEXT  = "Enter username";
export const OR_TEXT = "OR";

export const SETTING_TAB = {
    PLATFORM: {key: "platform", labelKey: "settings.settingTabPlatform"},
    USER: {key: "user", labelKey: "settings.settingTabUser"},
    BRANDING: {key: "branding", labelKey: "settings.settingTabBranding"},
};


export const IMPORT_QUESTION_BANK_TEXT  = "Import Question Bank";
export const ACTIVITY_EDITOR_VIEW = {
    OVERVIEW: "OVERVIEW",
    CONFIGURATION: "CONFIGURATION",
    QUESTION_EDITING: "QUESTION_EDITING",
    ATTENDANCE_EDITING: "ATTENDANCE_EDITING",
    SAVE_SUCCESS: "SAVE_SUCCESS",
    IMPORT_QUESTIONS: "IMPORT_QUESTIONS",
};

export const VIEW_ALL_ACTIVITIES_TEXT = "View All Activities";
export const EVP_TEXT = "EVP";
export const CHOOSE_GRADE_OPTION_BEFORE_ADD_QUESTION_TEXT = "Choose a grading option before adding questions.";
export const QUESTION_MAX_POINTS = 1000;
export const COPIED_TEXT = "Copied";

export const NEED_HELP_TEXT = "Need help? Contact";

export const SYNC_LMS_OPTIONS = {
    EMBEDDED: "EMBEDDED",
    LMS_API_SYNC: "LMS_API_SYNC",
};

export const PPT_INSERT_PAGE_VIEW = {
    ACTIVITY_LIST_VIEW: "ACTIVITY_LIST_VIEW",
    ACTIVITY_RELEASE_OPTION_VIEW: "ACTIVITY_RELEASE_OPTION_VIEW"
};

export const GRADE_SCHEMA = {
    GRADED: {
        key: "GRADED",
        nameKey: "questionBuilder.gradeSchemaGraded.name",
        descriptionKey: "questionBuilder.gradeSchemaGraded.description",
        image: GRADED_ACTIVITY_IMG
    },
    UNGRADED: {
        key: "UNGRADED",
        nameKey: "questionBuilder.gradeSchemaUngraded.name",
        descriptionKey: "questionBuilder.gradeSchemaUngraded.description",
        image: UNGRADED_ACTIVITY_IMG
    },
};


export const RELEASE_ACTIVITY_VIEW = {
    INVALID_ACTIVITY_VIEW: "INVALID_ACTIVITY_VIEW",
    ONE_MORE_STEP_VIEW: "ONE_MORE_STEP_VIEW",
    RELEASE_OPTION_VIEW: "RELEASE_OPTION_VIEW",
    RELEASE_VIEW: "RELEASE_VIEW",
    METRIC_VIEW: "METRIC_VIEW",

};


export const PPT_INSTALLATION_OVERVIEW_LINK = "https://demo.video.yuja.com/V/Video?v=13920724&node=60818301&a=188290704";
export const PPT_INSTALLATION_STEP_1_LINK = "https://demo.video.yuja.com/V/Video?v=13920730&node=60818308&a=146152802";
export const PPT_INSTALLATION_STEP_2_LINK = "https://demo.video.yuja.com/V/Video?v=13920732&node=60818310&a=212507268";
export const PPT_INSTALLATION_STEP_3_LINK = "https://demo.video.yuja.com/V/Video?v=13920733&node=60818311&a=136554199";
export const PPT_INSTALLATION_STEP_4_LINK = "https://demo.video.yuja.com/V/Video?v=13920734&node=60818312&a=49066749";

export const PPT_INSTALLATION_LEARN_MORE_LINK = "https://support.yuja.com/hc/en-us/articles/34382467031959-Uninstalling-the-Engage-Add-In-for-PowerPoint-and-Keynote";
export const NO_QR_CODE_OR_POLL_CODE_TO_SHARE = "This #activityType is embedded in a course and cannot be shared through a Join Code or QR Code.\n Share the link below so participants can sign in to their course and join the #activityType.";
export const ACTIVITY_TYPE_PLACEHOLDER = "#activityType";


export const PPT_RUNNING_APP_TYPE = {
    POWERPOINT: "POWERPOINT",
    KEYNOTE: "KEYNOTE",
    GOOGLE_SLIDES: "GOOGLE_SLIDES",
    BOTH: "BOTH",
    NONE: "NONE"
};
export const PPT_CACHED_INSERTING_ACTIVITY_NAME = "PPT_cached_inserting_activity";
export const SET_UP_RELEASE_TEXT = "Set Up Release";


export const CSM_INSTITUTION_TABLE_SHORT_NAME_HEADER = "Short Name";


export const INTEGRATION_BUTTON = {
    LTI_1_DOT_3: {key: "LTI1.3", label: "LTI 1.3"},
    API: {key: "LMS_API", label: "LMS API"},
};

export const QUIZ_TYPE = "Quiz Type";

// TODO: replace placeholder linkUrl ("#") values once the corresponding guide links are provided.
export const INTEGRATION_GUIDE = {
    CANVAS: {
        apiAccessGuide: {
            descriptionKey: "integration.guide.apiAccessDescription",
            linkTextKey: "integration.guide.apiAccessLinkText",
            params: {lms: "Canvas"},
            linkUrl: "https://support.yuja.com/hc/en-us/articles/10295963631895-Integrating-Engage-into-Canvas-Using-LTI-1-3#h_01HJ6PWQGTFWJ5EGYGYRY6VZ97",
        },
        ltiIntegrationGuide: {
            descriptionKey: "integration.guide.ltiIntegrationDescription",
            linkTextKey: "integration.guide.ltiIntegrationLinkText",
            suffixKey: "integration.guide.ltiIntegrationSuffix",
            params: {lms: "Canvas"},
            linkUrl: "https://support.yuja.com/hc/en-us/articles/10295963631895-Integrating-Engage-into-Canvas-Using-LTI-1-3#integrating-yuja-engage-lti-1-3-0-0",
        },
        accessKeyGuide: {
            descriptionKey: "integration.guide.accessKeyDescriptionCanvas",
            linkTextKey: "integration.guide.accessKeyLinkTextCanvas",
            linkUrl: "https://support.yuja.com/hc/en-us/articles/10295963631895-Integrating-Engage-into-Canvas-Using-LTI-1-3#h_01HJ6PWQGTFWJ5EGYGYRY6VZ97",
        },
    },
    BLACKBOARD: {
        apiAccessGuide: {
            descriptionKey: "integration.guide.apiAccessDescription",
            linkTextKey: "integration.guide.apiAccessLinkText",
            params: {lms: "Blackboard"},
            linkUrl: "https://support.yuja.com/hc/en-us/articles/12223661985303-Integrating-Engage-into-Blackboard-Ultra-Using-LTI-1-3#h_01J3R5QB1AP5J982H09VJ85CBQ",
        },
        ltiIntegrationGuide: {
            descriptionKey: "integration.guide.ltiIntegrationDescription",
            linkTextKey: "integration.guide.ltiIntegrationLinkText",
            suffixKey: "integration.guide.ltiIntegrationSuffix",
            params: {lms: "Blackboard"},
            linkUrl: "https://support.yuja.com/hc/en-us/articles/12223661985303-Integrating-Engage-into-Blackboard-Ultra-Using-LTI-1-3#h_01J3R5QB1AYZSQDSPBDQ9PMHRF",
        },
        accessKeyGuide: {
            descriptionKey: "integration.guide.accessKeyDescriptionBlackboard",
            linkTextKey: "integration.guide.accessKeyLinkTextBlackboard",
            linkUrl: "https://support.yuja.com/hc/en-us/articles/12223661985303-Integrating-Engage-into-Blackboard-Ultra-Using-LTI-1-3#h_01J3R5QB1AP5J982H09VJ85CBQ",
        },
    },
    D2L: {
        apiAccessGuide: {
            descriptionKey: "integration.guide.apiAccessDescription",
            linkTextKey: "integration.guide.apiAccessLinkText",
            params: {lms: "D2L Brightspace"},
            linkUrl: "https://support.yuja.com/hc/en-us/articles/13285411230487-Integrating-Engage-into-D2L-Brightspace-Using-LTI-1-3#h_01HKANCM7SV68A42KZS8TK8HZH",
        },
        ltiIntegrationGuide: {
            descriptionKey: "integration.guide.ltiIntegrationDescription",
            linkTextKey: "integration.guide.ltiIntegrationLinkText",
            suffixKey: "integration.guide.ltiIntegrationSuffix",
            params: {lms: "D2L"},
            linkUrl: "https://support.yuja.com/hc/en-us/articles/13285411230487-Integrating-Engage-into-D2L-Brightspace-Using-LTI-1-3#h_01HA4YGAZ7ZVHQC68JHHVRXQ58",
        },
        accessKeyGuide: {
            descriptionKey: "integration.guide.accessKeyDescriptionD2l",
            linkTextKey: "integration.guide.accessKeyLinkTextD2l",
            linkUrl: "https://support.yuja.com/hc/en-us/articles/13285411230487-Integrating-Engage-into-D2L-Brightspace-Using-LTI-1-3#h_01HKANCM7SV68A42KZS8TK8HZH",
        },
    },
    MOODLE: {
        apiAccessGuide: {
            descriptionKey: "integration.guide.apiAccessDescription",
            linkTextKey: "integration.guide.apiAccessLinkText",
            params: {lms: "Moodle"},
            linkUrl: "https://support.yuja.com/hc/en-us/articles/18974947862423-Integrating-the-Engage-API-into-Moodle#h_01KABVY6RQK2XEXAT4Z9A6NDR2",
        },
        ltiIntegrationGuide: {
            descriptionKey: "integration.guide.ltiIntegrationDescription",
            linkTextKey: "integration.guide.ltiIntegrationLinkText",
            suffixKey: "integration.guide.ltiIntegrationSuffix",
            params: {lms: "Moodle"},
            linkUrl: "https://support.yuja.com/hc/en-us/articles/13257597267863-Integrating-Engage-into-Moodle-Using-LTI-1-3#h_01HQNSKJFBDNHBYW7K49Y4WS2V",
        },
        accessKeyGuide: {
            descriptionKey: "integration.guide.accessKeyDescriptionMoodle",
            linkTextKey: "integration.guide.accessKeyLinkTextMoodle",
            linkUrl: "https://support.yuja.com/hc/en-us/articles/18974947862423-Integrating-the-Engage-API-into-Moodle#h_01HEX07TCEDDD1BATM7NA7Z45W",
        },
        plugin: {
            titleKey: "integration.guide.pluginTitle",
            downloadDescriptionKey: "integration.guide.pluginDownloadDescription",
            installedDescriptionKey: "integration.guide.pluginInstalledDescription",
            installLinkTextKey: "integration.guide.pluginInstallLinkText",
            guideUrl: "https://support.yuja.com/hc/en-us/articles/18974947862423-Integrating-the-Engage-API-into-Moodle#h_01HEX07TCEDDD1BATM7NA7Z45W",
            downloadButtonTextKey: "integration.guide.pluginDownloadButtonText",
        },
    },
    COMMON: {
        accessKeyLabelKey: "integration.guide.commonAccessKeyLabel",
        accessKeyDescriptionKey: "integration.guide.commonAccessKeyDescription",
        addAccessKeyButtonTextKey: "integration.guide.commonAddAccessKeyButtonText",
        addAccessKeyModalDescriptionKey: "integration.guide.commonAddAccessKeyModalDescription",
        lmsApiLinkDescriptionKey: "integration.guide.commonLmsApiLinkDescription",
    },
};

